/**
 * Русское склонение существительного при числительном.
 *
 * Интерфейс постоянно показывает счётчики — «3 строки», «21 кандидат»,
 * «5 колонок». Без склонения выходит «Закреплено 4 колонок», и таблица
 * начинает выглядеть как черновик. Правило одно на всё приложение,
 * поэтому и живёт здесь, а не переписывается в каждом компоненте.
 */
export function plural(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(n);
  const m10 = abs % 10;
  const m100 = abs % 100;

  // 11–14 — исключение: «одиннадцать колонок», а не «одиннадцать колонка»
  if (m100 >= 11 && m100 <= 14) return many;
  if (m10 === 1) return one;
  if (m10 >= 2 && m10 <= 4) return few;
  return many;
}

/** То же, но сразу с числом: `pluralize(3, 'строка', 'строки', 'строк')` → «3 строки». */
export function pluralize(n: number, one: string, few: string, many: string): string {
  return `${n.toLocaleString('ru-RU')} ${plural(n, one, few, many)}`;
}
